import Select from "@imminently/decisively-ui/Select";
import React from "react";
import { useGraphVisualisation } from "../../../hooks/useGraphVisualisation";

const NodeLimitSelector = (props: {}) => {
  const { setNodeRenderLimit, nodeRenderLimit } = useGraphVisualisation();

  const options = React.useMemo(
    () =>
      [100, 200, 300, 400, 600, 800, 1000].map((i) => ({
        value: i.toString(),
        label: i.toString(),
      })),
    [],
  );

  const currentValue = React.useMemo(() => {
    return nodeRenderLimit?.toString() || null;
  }, [nodeRenderLimit]);

  const handleChange = React.useCallback(
    (value: string | null) => {
      if (value) {
        setNodeRenderLimit(Number(value));
      }
    },
    [setNodeRenderLimit],
  );

  return (
    <Select
      value={currentValue}
      options={options}
      onValueChange={handleChange}
      placeholder="Limit"
      className="min-w-[8.5rem]"
    />
  );
};

export default NodeLimitSelector;
